import { createContext, useEffect, useState, type ReactNode } from 'react';

interface IsMobileContextValue {
  isMobile: boolean;
  isNarrow: boolean;
}

export const IsMobileContext = createContext<IsMobileContextValue | null>(null);

function matchesMax(breakpoint: number): boolean {
  return typeof window !== 'undefined'
    ? window.matchMedia(`(max-width: ${breakpoint - 1}px)`).matches
    : false;
}

function useMediaQuery(breakpoint: number): boolean {
  const [matches, setMatches] = useState(() => matchesMax(breakpoint));

  useEffect(() => {
    const mq = window.matchMedia(`(max-width: ${breakpoint - 1}px)`);
    setMatches(mq.matches);
    const handler = (e: MediaQueryListEvent) => setMatches(e.matches);

    if (typeof mq.addEventListener === 'function') {
      mq.addEventListener('change', handler);
      return () => mq.removeEventListener('change', handler);
    } else {
      mq.addListener(handler);
      return () => mq.removeListener(handler);
    }
  }, [breakpoint]);

  return matches;
}

export function IsMobileProvider({ children }: { children: ReactNode }) {
  const isMobile = useMediaQuery(768);
  const isNarrow = useMediaQuery(1024);

  return <IsMobileContext.Provider value={{ isMobile, isNarrow }}>{children}</IsMobileContext.Provider>;
}

